/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SupportService {

    /**
     * Requests a company's hire and hire go feature flags
     * Return hire and hire go feature flags for the logged in user, if hire go flags are null, the account does not support the hire go product
     * @param xAccessToken
     * @returns any successful
     * @throws ApiError
     */
    public static getInternalApiWxCompanySettingsFeatureFlags(
        xAccessToken: string,
    ): CancelablePromise<{
        hire: Record<string, (string | boolean)>;
        hire_go: Record<string, boolean> | null;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/wx/company_settings/feature_flags',
            headers: {
                'X-ACCESS-TOKEN': xAccessToken,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }

}